<div id="pheno-filters-panel">
  <div id="measures-dropdown">
    <gpf-pheno-measure-selector-beta
      [datasetId]="selectedDatasetId"
      (selectedMeasureChange)="addMeasure($event)"
      [isFamilyFilters]="isFamilyFilters">
    </gpf-pheno-measure-selector-beta>
  </div>

  <div *ngFor="let histogram of selectedMeasureHistograms" class="filters-container">
    <gpf-person-filter
      [selectedMeasure]="histogram.measureHistogram"
      [initialState]="histogram.state"
      (updateState)="addToState($event)"
      (updateHistogram)="loadHistogram($event)"
      [isFamilyFilters]="isFamilyFilters"></gpf-person-filter>

    <div>
      <gpf-remove-button
        [id]="histogram.measureHistogram.measure + '-remove-button'"
        [field]="histogram.measureHistogram.measure"
        (removeFilter)="removeFromState($event)"></gpf-remove-button>
    </div>
  </div>
  <div style="margin: 10px 55px">
    <gpf-errors-alert [errors]="errors"></gpf-errors-alert>
  </div>
</div>
